import { createLogger } from "../utils/logger";

const logger = createLogger("classificationConfig");

export type EventClassificationId = "business" | "personal" | "team" | "external";

export interface EventClassification {
  id: EventClassificationId;
  name: string;
  color: string;
  description?: string;
  promptLabel?: string;
  isDefault?: boolean;
}

export const EVENT_CLASSIFICATIONS: EventClassification[] = [
  { id: "business", name: "Business", color: "#1976d2", isDefault: true, promptLabel: "Business" },
  { id: "personal", name: "Personal", color: "#9c27b0", promptLabel: "Personal" },
  { id: "team", name: "Team", color: "#388e3c", promptLabel: "Team" },
  { id: "external", name: "External", color: "#f57c00", promptLabel: "External" },
];

export function getClassificationColor(id?: string): string {
  if (!id) {
    const def = EVENT_CLASSIFICATIONS.find((c) => c.isDefault) || EVENT_CLASSIFICATIONS[0];
    return def.color;
  }
  const match = EVENT_CLASSIFICATIONS.find((c) => c.id === id);
  return match ? match.color : EVENT_CLASSIFICATIONS[0].color;
}

export function getClassificationOptions(): { id: EventClassificationId; name: string }[] {
  return EVENT_CLASSIFICATIONS.map((c) => ({ id: c.id, name: c.name }));
}

export function buildClassifierPromptList(): string {
  try {
    return EVENT_CLASSIFICATIONS.map((c) => c.promptLabel || c.name).join(", ");
  } catch (e) {
    logger.warn("Failed to build classifier prompt list", e as Error);
    return EVENT_CLASSIFICATIONS.map((c) => c.name).join(", ");
  }
}
